var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-wrapper"},[_c('div',{staticClass:"spotlight-card"},[(_vm.state === 'success')?_c('EmailVerificationSuccess',{on:{"goToApollo":_vm.onGoToApollo}}):_vm._e(),(_vm.state === 'invalid')?_c('EmailVerificationInvalid'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }